import { useState } from "react";
import { toast } from "sonner";
import { Check, Facebook, Link2, Twitter } from "lucide-react";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35zM12.05 21.79h-.01a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.72.98.99-3.63-.23-.37a9.79 9.79 0 0 1-1.5-5.22c0-5.42 4.41-9.83 9.84-9.83a9.77 9.77 0 0 1 6.95 2.88 9.77 9.77 0 0 1 2.88 6.96c0 5.42-4.42 9.81-9.84 9.81zm8.37-18.18A11.72 11.72 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.94L.06 24l6.31-1.66a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.16-3.53-8.28z" />
  </svg>
);

export const ShareButtons = ({ productName }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.href;
  const text = `Check out ${productName} from EHP — natural homeopathic remedy: ${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link copied to clipboard");
    setTimeout(() => setCopied(false), 2000);
  };

  const btn = "inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-white text-foreground/70 transition-colors hover:text-white";

  return (
    <div className="mt-8" data-testid="product-share-buttons">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Share this remedy</span>
      <div className="mt-3 flex gap-3">
        <a
          href={`https://wa.me/?text=${encodeURIComponent(text)}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on WhatsApp"
          className={`${btn} hover:border-[#25D366] hover:bg-[#25D366]`}
          data-testid="share-whatsapp-button"
        >
          <WhatsAppIcon style={{ height: 18, width: 18 }} />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Facebook"
          className={`${btn} hover:border-[#1877F2] hover:bg-[#1877F2]`}
          data-testid="share-facebook-button"
        >
          <Facebook className="h-4 w-4" />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on X"
          className={`${btn} hover:border-black hover:bg-black`}
          data-testid="share-twitter-button"
        >
          <Twitter className="h-4 w-4" />
        </a>
        <button
          type="button"
          onClick={copy}
          title="Copy link"
          className={`${btn} hover:border-primary hover:bg-primary`}
          data-testid="share-copy-link-button"
        >
          {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
};
